import { render, staticRenderFns } from "./FeatureTags.vue?vue&type=template&id=0e1a27da&scoped=true&lang=pug"
import script from "./FeatureTags.vue?vue&type=script&lang=js"
export * from "./FeatureTags.vue?vue&type=script&lang=js"
import style0 from "./FeatureTags.vue?vue&type=style&index=0&id=0e1a27da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e1a27da",
  null
  
)

export default component.exports